import { Tabs } from "antd";
import TableComponent from "components/generalComponents/tableComponent/TableComponent";
import { PureComponent, ReactNode } from "react";
import { strings } from "utils/localizedStrings";
import { GeneralConstants } from "../../constants/GeneralConstants";
import {
  GeneralRowType,
  GeneralTabType,
  IGeneralReportTablesProps,
} from "../../interfaces/IGenerals";

export default class GeneralReportTablesComponent extends PureComponent<IGeneralReportTablesProps> {
  render(): ReactNode {
    const {
      activeTab,
      currency,
      loading,
      onTabChange,
      periodLabels,
      revenueData,
      volumeData,
    } = this.props;
    const revenueColumns = GeneralConstants.buildColumns(
      periodLabels,
      currency,
      "currency",
    );
    const volumeColumns = GeneralConstants.buildColumns(
      periodLabels,
      currency,
      "number",
    );

    return (
      <div className="bg-white rounded-lg shadow p-4">
        <Tabs
          activeKey={activeTab}
          centered
          onChange={(key) => onTabChange(key as GeneralTabType)}
          items={[
            {
              key: "revenue",
              label: strings.General.Revenue.Label,
              children: (
                <TableComponent<GeneralRowType>
                  data={{
                    columns: revenueColumns,
                    dataSource: revenueData,
                    loading,
                    loadingTitle: strings.GlobalLabels.Loading,
                    page: 0,
                    pageSize: revenueData.length || 10,
                    total: revenueData.length,
                    totalTitle: strings.GlobalLabels.Total,
                    scroll: { x: null, y: 600 },
                  }}
                />
              ),
            },
            {
              key: "volume",
              label: strings.General.Revenue.Transaction,
              children: (
                <TableComponent<GeneralRowType>
                  data={{
                    columns: volumeColumns,
                    dataSource: volumeData,
                    loading,
                    loadingTitle: strings.GlobalLabels.Loading,
                    page: 0,
                    pageSize: volumeData.length || 10,
                    total: volumeData.length,
                    totalTitle: strings.GlobalLabels.Total,
                    scroll: { x: null, y: 600 },
                  }}
                />
              ),
            },
          ]}
        />
      </div>
    );
  }
}
